import React, { useContext } from "react";
import { Context as AdminContext } from "@components/ui-builder/admin-context";
import { getLikeCount } from "./teaser/SocialButtons";
import compare from "mibaby-common/util/compare";

export const sortItems = (items, sort, filter) =>
  sort || filter
    ? items.slice().sort((a, b) => {
        let val;
        switch (sort) {
          case "top":
            val = -compare(a.is_top || 0, b.is_top || 0);
          case "likes":
            val = val || -compare(getLikeCount(a), getLikeCount(b));
            break;
          case "created":
            val = -compare(a.created || "", b.created || "");
            break;
        }
        return val || a.sort - b.sort;
      })
    : items;

export const DEFAULT_OPTIONS = [
  ["top", "Highlights"],
  ["likes", "Beliebteste"],
  ["created", "Neuste"],
];

export const Sort = ({ sort, defaultSort, onSort, className = "", options = DEFAULT_OPTIONS }) => {
  if (defaultSort) {
    options = [...options].sort(([a], [b]) => (a === defaultSort ? -1 : b === defaultSort ? 1 : 0));
  }

  return (
    <div className={className + " form-group"}>
      <select className="form-control" value={sort} onChange={e => onSort(e.target.value)}>
        {options.map(([val, label]) => (
          <option key={val} value={val}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default props => {
  const isAdmin = useContext(AdminContext);
  return props.sort && !isAdmin ? <Sort {...props} /> : null;
};
